export const ACTIVE_HEADER_CLASS = 'shadow-[inset_0px_-4px] shadow-secondary_extra_light';
